export default "__VITE_ASSET__85810189__"